import { useForm } from "@refinedev/react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useTranslate } from "@refinedev/core";

import { isValidCNPJ } from "@modules/agreements/utils/isValidCNPJ";
import { useCreateAgreementMutation } from "@modules/agreements/services/mutations";
import { AgreementFormValues, agreementSchema } from "@modules/agreements/validations/agreementSchema";

export function useFluxCreateForm() {
  const translate = useTranslate();
  const { mutateAsync, isPending } = useCreateAgreementMutation();

  const methods = useForm<AgreementFormValues>({
    resolver: zodResolver(agreementSchema({
      cnpj: {
        validate: async (value) => isValidCNPJ(value),
        errorMessage: translate("v1/agreement_admin.errors.invalidCNPJ"),
      },
      volumetryEmailDay: translate("v1/agreement_admin.errors.volumetryEmailDay"),
      invalidEmail: translate("v1/agreement_admin.errors.invalidEmail"),
    })),
    mode: "onBlur",
  });

  const {
    handleSubmit,
  } = methods;

  return {
    methods,
    isPending,
    handleSubmit,
    mutateAsync,
  };
}
